export default {
  'Note.OtherUserMessage': ({ action, url }, outlet) => {
    outlet({ action, url })
  },
  'Note.CurrentUserMessage': ({ action, url, note }, outlet) => {
    outlet({ action, url, note })
  },
}